import React from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Footprint,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import TextInput from '/component/base/TextInput';
import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';

const styles = StyleSheet.create({
  fieldContainer: {
    width: '100%',
  },
});

storiesOf('base', module).add('TextInput', () => (
  // @ts-expect-error TS(2322): Type '{ children: Element; isStorybook: boolean; }... Remove this comment to see the full error message
  <KeyboardAvoidingView isStorybook={true}>
    <ScrollView>
      <Spacing size={20}>
        <FlexView>
          <Heading level={1}>TextInput</Heading>
          <Spacer size={24} />
          <Text>
            The <Code>TextInput</Code> component is a decorator around React
            Native's built in <Code>TextInput</Code> component.
          </Text>
          <Spacer size={16} />
          <Text>
            The decorated <Code>TextInput</Code> component by sets up some
            styling override, but is otherwise compatible with the built in{' '}
            <Code>TextInput</Code> component.
          </Text>
          <Spacer size={16} />
          <View style={styles.fieldContainer}>
            <Footprint>
              <TextInput value="Text input value" />
            </Footprint>
          </View>
          <Spacer size={16} />
          <View style={styles.fieldContainer}>
            <Footprint>
              <TextInput placeholder="Text input placeholder value" />
            </Footprint>
          </View>
          <Spacer size={24} />
          <Heading level={2}>Disabled State</Heading>
          <Spacer size={16} />
          <Text>
            The <Code>TextInput</Code> component can be disabled by setting the{' '}
            <Code>{'disabled={true}'}</Code> prop.
          </Text>
          <Spacer size={16} />
          <Text>
            The <Code>TextInput</Code> value can be greyed out by setting the{' '}
            <Code>{'disabled={true} and greyOutTextInputValue={true}'}</Code>{' '}
            props.
          </Text>
          <Spacer size={16} />
          <View style={styles.fieldContainer}>
            <Footprint>
              <TextInput
                // @ts-expect-error TS(2322): Type '{ value: string; disabled: boolean; greyOutT... Remove this comment to see the full error message
                value="Disabled text input value"
                disabled={true}
                greyOutTextInputValue
              />
            </Footprint>
          </View>
          <Spacer size={16} />
          <View style={styles.fieldContainer}>
            <Footprint>
              <TextInput
                // @ts-expect-error TS(2322): Type '{ placeholder: string; disabled: boolean; }'... Remove this comment to see the full error message
                placeholder="Disabled text input placeholder value"
                disabled={true}
              />
            </Footprint>
          </View>
          <Spacer size={24} />
          <Heading level={2}>Multi-Line Input</Heading>
          <Spacer size={16} />
          <Text>
            The <Code>TextInput</Code> component can be rendered in multi-line
            mode by setting the <Code>{'multiline={true}'}</Code> and{' '}
            <Code>{'numberOfLines={3}'}</Code> props.
          </Text>
          <Spacer size={16} />
          <View style={styles.fieldContainer}>
            <Footprint>
              <TextInput
                // @ts-expect-error TS(2322): Type '{ placeholder: string; multiline: boolean; n... Remove this comment to see the full error message
                placeholder="Multi-line text input placeholder value"
                multiline={true}
                numberOfLines={3}
              />
            </Footprint>
          </View>
        </FlexView>
      </Spacing>
    </ScrollView>
  </KeyboardAvoidingView>
));
